import {
  getAnalytics,
  isSupported as isAnalyticsSupported,
} from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  deleteToken,
  getMessaging,
  getToken,
  onMessage,
} from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDogZ389DCN67ehLiIHApZlQAFWHP62gDU",
  authDomain: "eattake-102e6.firebaseapp.com",
  projectId: "eattake-102e6",
  storageBucket: "eattake-102e6.firebasestorage.app",
  messagingSenderId: "887813217731",
  appId: "1:887813217731:web:969681c9230836b4803176",
  measurementId: "G-P4DEHP6E6Q",
};

const vapidKey =
  "BGqQ5QRcspm53zRbl8Uy1QDPhZzB9hOZ8nDYm8yELi9u7j6mhcJpmsKiIrvxWxh2LXeWCjnRXiJ5OAjsbwYBqkM";

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export const initializeFirebase = async (): Promise<void> => {
  if (await isAnalyticsSupported()) {
    getAnalytics(app);
  }

  await requestNotificationPermission();
};

const requestNotificationPermission = async (): Promise<void> => {
  const permission = Notification.permission;
  if (permission === "granted") {
    await registerToken();
  } else if (sessionStorage.getItem("DEVICE_TOKEN")) {
    await removeToken();
  }
};

const registerToken = async (): Promise<void> => {
  try {
    const messaging = getMessaging(app);
    const registration = await navigator.serviceWorker.ready;

    const token = await getToken(messaging, {
      vapidKey,
      serviceWorkerRegistration: registration,
    });

    if (token) {
      sessionStorage.setItem("DEVICE_TOKEN", token);
    }

    setupNotificationListener(messaging);
  } catch (err) {
    console.error("Erro ao obter token FCM:", err);
  }
};

const removeToken = async (): Promise<void> => {
  try {
    const messaging = getMessaging(app);
    await deleteToken(messaging);
  } catch (err) {
    console.warn("Erro ao deletar token:", err);
  }
  sessionStorage.removeItem("DEVICE_TOKEN");
};

const setupNotificationListener = (
  messaging: ReturnType<typeof getMessaging>
): void => {
  onMessage(messaging, async (payload: any) => {
    const registration = await navigator.serviceWorker.ready;

    const notificationTitle = payload.notification.title || "Nova notificação";
    const notificationOptions = {
      body: payload.notification.body || "",
      icon: payload.notification.icon || "/img/icons/eattake-e2.png",
      tag: "pedido-notification",
      data: {
        url: payload.data.link || location.origin + "/#/PedidosRealizados",
      },
    };

    registration.showNotification(notificationTitle, notificationOptions);
  });
};

export { auth };
